import {gql} from "apollo-boost";

export const horaAtualQuery = gql`
  query horaAtualQuery {
    horaAtualQuery {
      value
    }
  }
`;

export const usuarioOneQuery = gql`
      query usuarioOneQuery($id: Int!) {
        usuarioOne(id: $id) {
          id
          nome
          email
        }
      }
`;

export const papelListQuery = gql`
      query papelListQuery($archived: Boolean!) {
        papelList (archived: $archived) {
          id
          id_descritivo
          nome
        }
      }
`;

export const usuarioAutoCompleteQuery = gql`
      query usuarioAutoCompleteQuery($nome: String!) {
        usuarioAutoComplete (nome: $nome) {
          id
          nome
          email
          identificador
        }
      }
`;

export const grupoAutoCompleteQuery = gql`
      query grupoAutoCompleteQuery($nome: String!) {
        grupoAutoComplete (nome: $nome) {
          id
          nome
        }
      }
`;

export const novaSessaoSave = gql`
  mutation novaSessaoSave($input: SessaoInput!) {
    novaSessaoSave(input: $input) {
        id
        slug
    }
  }
`;

export const addParticipantModalUserListQuery = gql`
  query addParticipantModalUserListQuery($nome: String!) {
    usuarioAutoComplete (nome: $nome) {
      id
      nome
      email
    }
  }
`;

export const desconhecidoDefineDados = gql`
  mutation desconhecidoDefineDados($input: DesconhecidoInput!) {
    desconhecidoDefineDados(input: $input)
  }
`;

export const layoutParticipanteOptionsQuery = gql`
  query layoutParticipanteOptionsQuery {
    layoutParticipanteOptions {
      id
      id_descritivo
      nome
    }
  }
`;

// export const addParticipantModalPapelListQuery = gql`
//   query addParticipantModalPapelListQuery {
//     papelListModalAddParticipant {
//       id
//       nome
//     }
//   }
// `;
